import React, { useState } from 'react';
import { CarIcon, TruckIcon, WrenchIcon, ChevronDownIcon, ChevronUpIcon, CheckCircleIcon, ClipboardListIcon, PhoneIcon } from 'lucide-react';
export function Services() {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const toggleSection = (key: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return <section id="services" className="py-20 bg-white" data-id="element-323">
      <div className="container mx-auto px-4" data-id="element-324">
        <div className="max-w-6xl mx-auto" data-id="element-325">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-326">
            Auto & Truck Repair Services
          </h2>
          <p className="text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto" data-id="element-327">
            Expert diagnostic, repair, and maintenance services for all makes
            and models. From passenger vehicles to heavy-duty commercial trucks.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-328">
            {/* Automotive Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-329">
              <div className="relative h-64 overflow-hidden" data-id="element-330">
                <img src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&q=80" alt="Automotive repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-331" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-332"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-333">
                  <div className="flex items-center mb-2" data-id="element-334">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-335">
                      <CarIcon size={28} className="text-white" data-id="element-336" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-337">
                      Automotive Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-338">
                    Complete repair and maintenance for cars, SUVs, and light
                    trucks
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-339">
                <p className="text-gray-700 mb-4" data-id="element-340">
                  Expert mechanics providing comprehensive service, maintenance,
                  diagnostics, and repair for all makes and models of passenger
                  vehicles, SUVs, and light-duty trucks. From routine oil
                  changes to complex engine rebuilds.
                </p>

                <button onClick={() => toggleSection('automotive')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-341">
                  {expandedSections['automotive'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-342" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-343" />
                      View All Services
                    </>}
                </button>

                {expandedSections['automotive'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-344">
                    <div className="grid sm:grid-cols-2 gap-4" data-id="element-345">
                      <div data-id="element-346">
                        <ul className="space-y-2 text-gray-700" data-id="element-347">
                          <li data-id="element-348">• Complete diagnostic services</li>
                          <li data-id="element-349">• Brake service and repair</li>
                          <li data-id="element-350">• Engine repair and rebuilding</li>
                          <li data-id="element-351">• Transmission service</li>
                          <li data-id="element-352">• Suspension and steering</li>
                          <li data-id="element-353">• Electrical system diagnosis</li>
                          <li data-id="element-354">• Air conditioning service</li>
                          <li data-id="element-355">• Heating system repair</li>
                        </ul>
                      </div>
                      <div data-id="element-356">
                        <ul className="space-y-2 text-gray-700" data-id="element-357">
                          <li data-id="element-358">• Oil changes and fluid services</li>
                          <li data-id="element-359">• Tire service and alignment</li>
                          <li data-id="element-360">• Battery testing and replacement</li>
                          <li data-id="element-361">• Exhaust system repair</li>
                          <li data-id="element-362">• Cooling system service</li>
                          <li data-id="element-363">• Fuel system service</li>
                          <li data-id="element-364">• Preventive maintenance</li>
                          <li data-id="element-365">• State inspections</li>
                        </ul>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>

            {/* Commercial Truck Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-366">
              <div className="relative h-64 overflow-hidden" data-id="element-367">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/k3EFMSrFyz7J33HnvHTHeb/fleet-maint.jpg" alt="Commercial truck repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-368" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-369"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-370">
                  <div className="flex items-center mb-2" data-id="element-371">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-372">
                      <TruckIcon size={28} className="text-white" data-id="element-373" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-374">
                      Commercial Truck Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-375">
                    Specialized service for medium and heavy-duty commercial
                    vehicles
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-376">
                <p className="text-gray-700 mb-4" data-id="element-377">
                  Comprehensive commercial truck repair and maintenance
                  specialists. We service all medium and heavy-duty commercial
                  vehicles, from routine maintenance to complete diagnostic and
                  repair services. Diesel and gas-powered vehicles.
                </p>

                <button onClick={() => toggleSection('commercial')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-378">
                  {expandedSections['commercial'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-379" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-380" />
                      View All Services
                    </>}
                </button>

                {expandedSections['commercial'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-381">
                    <p className="text-gray-700 mb-4" data-id="element-382">
                      Garrett Auto & Truck Service is well known in Southeast
                      Michigan for commercial truck service. Our master
                      mechanics keep your commercial fleet rolling with expert
                      maintenance and repair.
                    </p>
                    <div className="bg-black text-white p-4 rounded border-l-4 border-[#B1050B]" data-id="element-383">
                      <p className="font-bold text-[#B1050B] mb-2" data-id="element-384">
                        Commercial Fleet Care Services
                      </p>
                      <p className="text-gray-300" data-id="element-385">
                        Specialized maintenance programs for commercial fleets.
                        Call now to get scheduled for comprehensive fleet
                        maintenance and repair.
                      </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>

          {/* Fleet Maintenance Program - Expanded Full Width */}
          <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-lg shadow-2xl overflow-hidden border-2 border-black" data-id="element-386">
            <div className="grid lg:grid-cols-5 gap-0" data-id="element-387">
              <div className="lg:col-span-2 relative h-96 lg:h-auto" data-id="element-388">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/diQWqXykJ7zyqrF7FJPm6g/Commercial-Trucks.png" alt="Commercial work truck fleet in urban setting" className="w-full h-full object-cover" data-id="element-389" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-900/30 to-gray-900" data-id="element-390"></div>
              </div>

              <div className="lg:col-span-3 p-8 lg:p-10 text-white" data-id="element-391">
                <div className="flex items-center mb-6" data-id="element-392">
                  <div className="bg-[#B1050B] p-3 rounded-lg mr-4" data-id="element-393">
                    <WrenchIcon size={36} className="text-white" data-id="element-394" />
                  </div>
                  <div data-id="element-395">
                    <h3 className="text-3xl font-bold mb-1" data-id="element-396">
                      Fleet Maintenance Program
                    </h3>
                    <p className="text-[#D4AF37] font-medium" data-id="element-397">
                      For Commercial Work Trucks & Vehicles
                    </p>
                  </div>
                </div>

                <div className="space-y-4 mb-6" data-id="element-398">
                  <p className="text-gray-300 text-lg leading-relaxed" data-id="element-399">
                    Many truck and fleet owners postpone simple maintenance
                    procedures because taking vehicles to a service center eats
                    up valuable man-hours. The drop-off, pickup, and retrieval
                    process costs time and productivity.
                  </p>

                  <p className="text-gray-300 text-lg leading-relaxed" data-id="element-400">
                    <strong className="text-white" data-id="element-401">The real cost?</strong>{' '}
                    Ignoring scheduled maintenance leads to breakdowns on the
                    side of the road, extended downtime, and problems that could
                    have been prevented. We eliminate these hassles with our
                    comprehensive fleet program.
                  </p>
                </div>

                <button onClick={() => toggleSection('fleet')} className="flex items-center text-[#D4AF37] hover:text-[#C9A961] font-bold text-lg transition-colors mb-6" data-id="element-402">
                  {expandedSections['fleet'] ? <>
                      <ChevronUpIcon size={24} className="mr-2" data-id="element-403" />
                      Show Less Details
                    </> : <>
                      <ChevronDownIcon size={24} className="mr-2" data-id="element-404" />
                      See How We Take the Hassle Out of Maintenance
                    </>}
                </button>

                {expandedSections['fleet'] && <div className="space-y-6" data-id="element-405">
                    {/* How It Works */}
                    <div className="bg-black/40 backdrop-blur-sm p-6 rounded-lg border border-gray-700" data-id="element-406">
                      <h4 className="font-bold text-2xl text-[#D4AF37] mb-4 flex items-center" data-id="element-407">
                        <ClipboardListIcon size={24} className="mr-2" data-id="element-408" />
                        How Our Fleet Program Works
                      </h4>
                      <div className="grid sm:grid-cols-2 gap-4" data-id="element-409">
                        <div className="flex items-start space-x-3" data-id="element-410">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-411" />
                          <p className="text-gray-300" data-id="element-412">
                            We maintain your service records and D.O.T.
                            recordkeeping requirements in our state-of-the-art
                            database
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-413">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-414" />
                          <p className="text-gray-300" data-id="element-415">
                            When it's time for service, we'll notify you in
                            advance
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-416">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-417" />
                          <p className="text-gray-300" data-id="element-418">
                            Our staff will pick up your vehicle on a day
                            convenient for you (usually Saturday)
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-419">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-420" />
                          <p className="text-gray-300" data-id="element-421">
                            We inform you of any safety or reliability concerns
                            upfront
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-422">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-423" />
                          <p className="text-gray-300" data-id="element-424">
                            You'll know exactly how long the vehicle will be out
                            of service
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-425">
                          <CheckCircleIcon size={20} className="text-[#D4AF37] flex-shrink-0 mt-1" data-id="element-426" />
                          <p className="text-gray-300" data-id="element-427">
                            When complete, we deliver your truck right to your
                            door
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Services Included */}
                    <div className="bg-[#B1050B]/20 backdrop-blur-sm p-6 rounded-lg border border-[#B1050B]/50" data-id="element-428">
                      <h4 className="font-bold text-xl text-white mb-4" data-id="element-429">
                        Fleet Maintenance Services Include:
                      </h4>
                      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-430">
                        <div className="text-gray-300" data-id="element-431">
                          • Oil & filter changes
                        </div>
                        <div className="text-gray-300" data-id="element-432">
                          • Chassis lubrication
                        </div>
                        <div className="text-gray-300" data-id="element-433">
                          • Transmission service
                        </div>
                        <div className="text-gray-300" data-id="element-434">• Brake adjustments</div>
                        <div className="text-gray-300" data-id="element-435">• Wheel alignment</div>
                        <div className="text-gray-300" data-id="element-436">
                          • Cooling system maintenance
                        </div>
                        <div className="text-gray-300" data-id="element-437">
                          • Fuel injection service
                        </div>
                        <div className="text-gray-300" data-id="element-438">
                          • Belt & hose replacement
                        </div>
                        <div className="text-gray-300" data-id="element-439">
                          • Clutch adjustments
                        </div>
                        <div className="text-gray-300" data-id="element-440">
                          • Preventive diagnostics
                        </div>
                        <div className="text-gray-300" data-id="element-441">• DOT compliance</div>
                        <div className="text-gray-300" data-id="element-442">• And much more</div>
                      </div>
                    </div>

                    {/* Value Proposition */}
                    <div className="bg-black/60 backdrop-blur-sm p-6 rounded-lg border-l-4 border-[#D4AF37]" data-id="element-443">
                      <p className="text-gray-200 text-lg leading-relaxed" data-id="element-444">
                        <strong className="text-[#D4AF37]" data-id="element-445">
                          Garrett Auto & Truck believes in preventative
                          maintenance.
                        </strong>{' '}
                        We'll help you save time and money by providing the
                        diagnostic, repair, and replacement services recommended
                        by your vehicle manufacturer. Keep your commercial fleet
                        running reliably and avoid costly breakdowns.
                      </p>
                    </div>

                    {/* CTA */}
                    <div className="text-center pt-4" data-id="element-446">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#D4AF37] text-black hover:bg-[#C9A961] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-447">
                        <PhoneIcon size={22} className="mr-2" data-id="element-448" />
                        Call (248) 478-8382 for Fleet Service
                      </a>
                    </div>
                  </div>}

                {!expandedSections['fleet'] && <div data-id="element-449">
                    <div className="grid sm:grid-cols-3 gap-4 mt-6" data-id="element-450">
                      <div className="text-center p-4 bg-black/40 rounded-lg border border-gray-700" data-id="element-451">
                        <div className="text-3xl font-bold text-[#D4AF37] mb-1" data-id="element-452">
                          Free
                        </div>
                        <div className="text-sm text-gray-400" data-id="element-453">
                          Pickup & Delivery
                        </div>
                      </div>
                      <div className="text-center p-4 bg-black/40 rounded-lg border border-gray-700" data-id="element-454">
                        <div className="text-3xl font-bold text-[#D4AF37] mb-1" data-id="element-455">
                          DOT
                        </div>
                        <div className="text-sm text-gray-400" data-id="element-456">
                          Record Keeping
                        </div>
                      </div>
                      <div className="text-center p-4 bg-black/40 rounded-lg border border-gray-700" data-id="element-457">
                        <div className="text-3xl font-bold text-[#D4AF37] mb-1" data-id="element-458">
                          24/7
                        </div>
                        <div className="text-sm text-gray-400" data-id="element-459">
                          Service Tracking
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-6" data-id="element-460">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#D4AF37] text-black hover:bg-[#C9A961] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-461">
                        Find Out More
                      </a>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}